import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { SiteProvider } from './context/SiteContext';
import { AuthProvider } from './context/AuthContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import { I18nProvider } from './context/I18nContext';
import { Toaster } from './components/ui/sonner';
import AgeGate from './components/AgeGate';

import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Page from './pages/Page';

import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import RequireAuth from './pages/admin/RequireAuth';
import Dashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminOrders from './pages/admin/AdminOrders';
import AdminCRM from './pages/admin/AdminCRM';
import AdminSEO from './pages/admin/AdminSEO';
import AdminMarketing from './pages/admin/AdminMarketing';
import AdminPayments from './pages/admin/AdminPayments';
import AdminSecurity from './pages/admin/AdminSecurity';
import AdminCategories from './pages/admin/AdminCategories';
import AdminPages from './pages/admin/AdminPages';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminReviews from './pages/admin/AdminReviews';
import AdminBranding from './pages/admin/AdminBranding';
import AdminUsers from './pages/admin/AdminUsers';
import AdminShipping from './pages/admin/AdminShipping';
import AdminMedia from './pages/admin/AdminMedia';
import OrderVoucher from './pages/OrderVoucher';
import OrderCryptoPay from './pages/OrderCryptoPay';
import OrderThanks from './pages/OrderThanks';
import AccountLogin from './pages/AccountLogin';
import AccountRegister from './pages/AccountRegister';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CustomerAuthProvider>
          <SiteProvider>
            <CartProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/p/:slug" element={<Page />} />
                <Route path="/order/:orderNumber/voucher" element={<OrderVoucher />} />
                <Route path="/order/:orderNumber/crypto" element={<OrderCryptoPay />} />
                <Route path="/order/:orderNumber/thanks" element={<OrderThanks />} />
                <Route path="/login" element={<AccountLogin />} />
                <Route path="/register" element={<AccountRegister />} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                  <Route index element={<Dashboard />} />
                  <Route path="products" element={<RequireAuth permission="products"><AdminProducts /></RequireAuth>} />
                  <Route path="media" element={<RequireAuth permission="products"><AdminMedia /></RequireAuth>} />
                  <Route path="categories" element={<RequireAuth permission="categories"><AdminCategories /></RequireAuth>} />
                  <Route path="pages" element={<RequireAuth permission="pages"><AdminPages /></RequireAuth>} />
                  <Route path="coupons" element={<RequireAuth permission="coupons"><AdminCoupons /></RequireAuth>} />
                  <Route path="reviews" element={<RequireAuth permission="reviews"><AdminReviews /></RequireAuth>} />
                  <Route path="orders" element={<RequireAuth permission="orders"><AdminOrders /></RequireAuth>} />
                  <Route path="crm" element={<RequireAuth permission="customers"><AdminCRM /></RequireAuth>} />
                  <Route path="seo" element={<RequireAuth permission="seo"><AdminSEO /></RequireAuth>} />
                  <Route path="marketing" element={<RequireAuth permission="marketing"><AdminMarketing /></RequireAuth>} />
                  <Route path="branding" element={<RequireAuth permission="branding"><AdminBranding /></RequireAuth>} />
                  <Route path="payments" element={<RequireAuth permission="payments"><AdminPayments /></RequireAuth>} />
                  <Route path="shipping" element={<RequireAuth permission="payments"><AdminShipping /></RequireAuth>} />
                  <Route path="security" element={<RequireAuth permission="security"><AdminSecurity /></RequireAuth>} />
                  <Route path="users" element={<RequireAuth permission="users"><AdminUsers /></RequireAuth>} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster theme="dark" />
            <AgeGate />
          </div>
            </CartProvider>
          </SiteProvider>
        </CustomerAuthProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
